import Hammer from 'vendor/hammerjs/hammer';
setTimeout(() => {
    let el1 = document.querySelector('.carousel_pager a:first-child.carousel_pager-item');
    let el2 = document.querySelector('.carousel_pager a:last-child.carousel_pager-item');
                            
    el1.classList.add('firstslide');
    el2.classList.add('lastslide');

    setInterval(() => {
                        
        if (document.querySelector('.carousel_pager-item--active').classList.contains('lastslide')) {

            document.querySelector('.firstslide').click();

        } else {

            document.querySelector('.carousel_pager-item--active').nextElementSibling.click();

        }
            
    }, 3000);
  
}, 2000);

/**
 * @module Carousel
 */
class Carousel {

    /**
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;
        this._columns = null;
        this._container = null;
        this._pager = null;
        this._pagerItems = null;
        this._prev = null;
        this._next = null;
        this._columnsVisible = null;
        this._totalSlides = null;
        this._currentSlide = 0;
        this._windowWidth = window.innerWidth;
        this._hammer = new Hammer(element);
        this.load();
    }


    /**
     * Base options
     */
    static get options() {
        return {
            classnameBtn: 'carousel_btn',
            clasnameBtnIcons: { prev: 'icon-arrow-left-white', next: 'icon-arrow-right-white' },
            classnameBtnDisabled: 'carousel_btn--disabled',
            classnameContainer: 'carousel_container',
            classnamePager: 'carousel_pager',
            classnamePagerItem: 'carousel_pager-item',
            classnamePagerItemActive: 'carousel_pager-item--active',
            selectorColumn: '.layout-column'
        };
    }


    /**
     * Construct module
     */
    load() {
        this._addContainer();
        this._addPrevNextBtns();
        this._calculate();
        this._addPager();
        this._addPagerItems();
        this._toggleCurrentPagerItem(true);
        this._addEventHandlers();
        this._updatePrevNextBtns();
    }


    /**
     * Add all the event listeners
     * @private
     */
    _addEventHandlers() {
        this._prev.addEventListener('click', this._onPrevClick.bind(this));
        this._next.addEventListener('click', this._onNextClick.bind(this));
        this._pager.addEventListener('click', this._onPagerClick.bind(this));
        window.addEventListener('resize', this._onResize.bind(this));
        this._hammer.on('swipeleft swiperight', this._onSwipe.bind(this));
    }


    /**
     * Handle previous button click event
     * @param {object} e - event object
     * @private
     */
    _onPrevClick(e) {
        e.preventDefault();
        this._updateCarousel(this._currentSlide - 1);
    }


    /**
     * Handle next button click event
     * @param {object} e - event object
     * @private
     */
    _onNextClick(e) {
        e.preventDefault();
        this._updateCarousel(this._currentSlide + 1);
    }

    /**
     * Handle pager item click event
     * @param {object} e - event object
     * @private
     */
    _onPagerClick(e) {
        e.preventDefault();

        const index = this._pagerItems.indexOf(e.target);

        if (index !== -1 && index !== this._currentSlide) {
            this._updateCarousel(index);
        }
    }


    /**
     * Handle element swipe event
     * @param {object} e - Hammer event object
     * @private
     */
    _onSwipe(e) {
        if (e.type === 'swipeleft' && !this._isLastSlideActive()) {
            this._updateCarousel(this._currentSlide + 1);
        } else if (e.type === 'swiperight' && !this._isFirstSlideActive()) {
            this._updateCarousel(this._currentSlide - 1);
        }
    }


    /**
     * Handle window resize event
     * @private
     */
    _onResize() {
        if (window.innerWidth !== this._windowWidth) {
            this._windowWidth = window.innerWidth;
            this._resetCarousel();
            this._calculate();
            this._addPagerItems();
            this._toggleCurrentPagerItem(true);
            this._updatePrevNextBtns();
        }
    }


    /**
     * Calculate all the values needed for the animation
     * @private
     */
    _calculate() {
        this._columnsVisible = Math.round(this._container.offsetWidth / this._columns[0].offsetWidth);
        // total number of slide / number of columns visible within container
        this._totalSlides = Math.ceil(this._columns.length / this._columnsVisible) - 1;
    }


    /**
     * Update the carousel to the correct slide position
     * @param {int} slide - The new slide number
     * @private
     */
    _updateCarousel(slide) {
        this._toggleCurrentPagerItem(false);
        this._setCurrentSlide(slide);
        this._toggleCurrentPagerItem(true);
        this._updatePrevNextBtns();
        this._animateCarousel();
    }


    /**
     * Reset the carousel to it's start position
     * @private
     */
    _resetCarousel() {
        this._currentSlide = 0;
        this._container.style.transform = null;
    }


    /**
     * Animate the carousel to its new position
     * @private
     */
    _animateCarousel() {
        this._container.style.transform = `translateX(-${this._columns[this._currentSlide * this._columnsVisible].offsetLeft}px)`;
    }


    /**
     * Set the current slide value
     * @param {int} slide - the slide index
     * @private
     */
    _setCurrentSlide(slide) {
        this._currentSlide = Math.max(0, Math.min(this._totalSlides, slide));
    }


    /**
     * Toggle the active state of the current page within the pager
     * @param {boolean} bool - enable or disable state
     * @private
     */
    _toggleCurrentPagerItem(bool) {
        if (this._totalSlides === 0) {
            return;
        }

        const elem = this._pagerItems[this._currentSlide];
        const classname = this._options.classnamePagerItemActive;

        bool ? elem.classList.add(classname) : elem.classList.remove(classname);
    }


    /**
     * Check if the prev and next buttons should be enabled or disabled
     * @private
     */
    _updatePrevNextBtns() {
        const prev = this._prev;
        const next = this._next;
        const classnameDisabled = this._options.classnameBtnDisabled;

        if (this._isFirstSlideActive()) {
            prev.classList.add(classnameDisabled);
        } else {
            prev.classList.remove(classnameDisabled);
        }

        if (this._isLastSlideActive()) {
            next.classList.add(classnameDisabled);
        } else {
            next.classList.remove(classnameDisabled);
        }
    }


    /**
     * Check if the first slide is active
     * @returns {boolean} - true or false
     * @private
     */
    _isFirstSlideActive() {
        return this._currentSlide === 0 || this._totalSlides === 0;
    }


    /**
     * Check if the last slide is active
     * @returns {boolean} - true or false
     * @private
     */
    _isLastSlideActive() {
        return this._currentSlide === this._totalSlides || this._totalSlides === 0;
    }


    /**
     * Add a wrapper container within the element
     * @private
     */
    _addContainer() {
        const container = document.createElement('div');
        const html = this._element.innerHTML;

        container.className = this._options.classnameContainer;
        container.innerHTML = html;

        this._element.innerHTML = '';
        this._element.appendChild(container);

        this._container = container;

        this._columns = this._container.querySelectorAll(this._options.selectorColumn);
    }


    /**
     * Add the pager container to the element
     * @private
     */
    _addPager() {
        const pager = document.createElement('div');

        pager.className = this._options.classnamePager;
        this._element.appendChild(pager);
        this._pager = pager;
    }


    /**
     * Add pages to the pager
     * @private
     */
    _addPagerItems() {
        const pager = this._pager;

        this._pager.innerText = '';
        this._pagerItems = [];

        if (this._totalSlides === 0) {
            return;
        }

        for (let i = 0; i <= this._totalSlides; i++) {
            const page = document.createElement('a');
            page.className = this._options.classnamePagerItem;
            page.href = '#';

            this._pagerItems.push(page);
            pager.appendChild(page);
        }
    }


    /**
     * Add the previous and next page buttons
     * @private
     */
    _addPrevNextBtns() {
        const classname = this._options.classnameBtn;

        ['prev', 'next'].forEach(type => {
            const el = document.createElement('a');
            el.className = `${classname} ${classname}-${type} icon ${this._options.clasnameBtnIcons[type]}`;
            el.href = '#';

            this._element.appendChild(el);
            this[`_${type}`] = el;
        });
    }

	
}

// Exports
export default Carousel;
